import { loadForElements } from './scripts/helpers/module-loader';
import "./scss/app.scss";
import "./scripts/aos.js";
import initElements from "./scripts/components/product-wishlist";
import { accordeon } from "./scripts/accordeon";
accordeon('.accordeon_item'); // import Swiper JS

import Swiper, { Navigation, Pagination, Thumbs } from 'swiper'; // import Swiper styles

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
var galleryThumbs = new Swiper(".gallery-thumbs", {
  modules: [Navigation],
  centeredSlides: false,
  centeredSlidesBounds: true,
  direction: "horizontal",
  spaceBetween: 10,
  slidesPerView: 2,
  freeMode: false,

  /* watchSlidesVisibility: true,
   watchSlidesProgress: true,
   watchOverflow: true,
   clickable: true,*/
  breakpoints: {
    480: {
      direction: "vertical",
      slidesPerView: 4
    }
  }
});
var galleryTop = new Swiper(".gallery-top", {
  modules: [Navigation, Thumbs],
  direction: "horizontal",
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  thumbs: {
    swiper: galleryThumbs
  }
});
galleryTop.on("slideChangeTransitionStart", function () {
  galleryThumbs.slideTo(galleryTop.activeIndex);
});
galleryThumbs.on("transitionStart", function () {
  galleryTop.slideTo(galleryThumbs.activeIndex);
}); // Product gallery

document.querySelectorAll('[data-carousel-product-gallery]').forEach(function (el) {
  new Swiper(el, {
    modules: [Navigation, Pagination],
    spaceBetween: 10,
    slidesPerView: 2,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: "[data-carousel-pagination]",
      clickable: true
    },
    breakpoints: {
      576: {
        spaceBetween: 20
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  });
});

if (document.getElementById('isSticky')) {
  var isSticky = {
    bodyClass: 'stixxed',
    obj: document.getElementById('isSticky'),
    height: document.getElementById('isSticky').clientHeight,
    width: document.getElementById('isSticky').clientWidth,
    offsetTop: window.scrollY,
    lastOffsetTop: null,
    hideScrollUp: false,
    update: function update() {
      this.lastOffsetTop = this.offsetTop;
      this.height = document.getElementById('isSticky').clientHeight;
      this.width = document.getElementById('isSticky').clientWidth;
      this.offsetTop = window.scrollY;
    },
    hide: function hide() {
      this.obj.style.top = -this.height + 'px';
      this.obj.style.opacity = 0;
      document.body.classList.remove(this.bodyClass);
    },
    show: function show() {
      this.obj.style.top = 0 + 'px';
      this.obj.style.opacity = 1;
      document.body.classList.add(this.bodyClass);
    },
    run: function run() {
      this.update();

      if (this.hideScrollUp === false) {
        if (this.offsetTop > this.height) {
          this.show();
        } else {
          this.hide();
        }
      }

      if (this.hideScrollUp === true) {
        if (this.lastOffsetTop > this.offsetTop && this.offsetTop > this.height) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }; // Bei Pageload verstecken

  isSticky.hide(); // On resize update

  window.addEventListener('resize', function () {
    isSticky.update();
  }); // activate on scroll

  window.addEventListener('scroll', function () {
    isSticky.run();
  });
}
/* mobile button */


var btn = $('.mobileMenuOpen .btn');
btn.on('click', function () {
  $(this).toggleClass('active');
  $(this).toggleClass('not-active');
  $('body').toggleClass('mobile_open');
}); // selections

var selections = document.querySelector('.selections');

if (selections) {
  setTimeout(function () {
    document.body.classList.add('add_ani');
  }, 200);
}
/* navi desktop */


var hero = document.querySelector('.hero1');

if (!hero) {
  document.body.classList.add('top_spacer');
} //aos


AOS.init({
  easing: 'ease-in-out-sine',
  offset: 250,
  delay: 400,
  duration: 800,
  once: true,
  disable: function disable() {
    var maxWidth = 992;
    return window.innerWidth < maxWidth;
  }
});
document.addEventListener("DOMContentLoaded", function () {
  AOS.refresh();
  initElements();
  loadForElements(document.querySelectorAll('[data-product-filter]'), function () {
    return import('./scripts/components/product-filter');
  });
});
var getOpenCookies = document.querySelector('.show_cookies button');

if (getOpenCookies) {
  getOpenCookies.addEventListener('click', function () {
    cookiebar.show(true);
  });
}